<template>
<div>
  <add-options></add-options>
  <option-table></option-table>
</div>
</template>

<script>
import AddOptions from "./AddOptions";
import OptionTable from "./OptionTable";

export default {
  components: {
    OptionTable,
    AddOptions
  },
  props: {
    optionData: Array
  }
}
</script>